// 開発用インポート
import "../sass/style.scss";

// swiper 初期化
const mySwiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,
	slidesPerView: 1.75,
	spaceBetween: 10,
	centeredSlides : true,
	breakpoints: {
    600: {
      slidesPerView: 3,
			spaceBetween: 10,
			centeredSlides : true,
    },
		740: {
      slidesPerView: 3,
			spaceBetween: 20,
    }
  },

  // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination',
  // },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

//scroll hint
new ScrollHint('.js-scrollable', {
	remainingTime: 5000,
  i18n: {
    scrollable: 'スクロールできます',
  },
});